var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dis_flex flex_dir_col ali_it_cen"},[_c('h1',{staticClass:"m_t_16"},[_vm._v("404")]),_c('h3',{staticClass:"m_t_16"},[_vm._v("请指定您要前往地址")])])
}]

export { render, staticRenderFns }